import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { SessionService } from '../../_shared/services/session.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private http: HttpClient, private sessionService: SessionService) {}

  searchProducts(params): Observable<any> {
    const apiUrl = environment.apiEndpoint + 'search_products';

    params.company_id = this.sessionService.getSelectedAccountCompany().id;

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(apiUrl, { params: queryParams });
  }

  getProduct(id, productType): Observable<any> {
    const url = environment.apiEndpoint + productType + '/' + id;
    let filterCriteria = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    let queryParams = new HttpParams({ fromObject: filterCriteria });

    return this.http.get<any>(url, { params: queryParams });
  }

  applyAccounting(product, productType, applyAccounting): Observable<any> {
    let url = environment.apiEndpoint + productType + 's/' + product.id + '/apply_accounting';
    const body = {
      [productType]: product,
    };

    if (applyAccounting) {
      url += '?apply_accounting=true';
    }

    return this.http.put<any>(`${url}`, body);
  }
}
